import React, { useState, useEffect } from 'react'
import { Box, Select, Title, Flex, Group, Button, SimpleGrid, Card, Text, ThemeIcon, TextInput } from '@mantine/core'
import { IconShip, IconTruck, IconPackage } from '@tabler/icons-react'
import { getAllCourierList } from '../../../../../services/courier'
import { useParams } from 'react-router-dom'
import { addPackageShipment, updatePackageShipment } from '../../../../../services/package'
import { validation } from '../../../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import LoadingData from '../../../../ui/LoadingData'

const defaultVal = {
  courier_name_slug: 'acn',
  tracking_code: '',
  last_mile_courier: null,
  tracking_code_courier: '',
  estimated_arrival: '',
  estimated_departure: '',
  port_of_landing: '',
  port_of_destination: ''
}

const formValidation = {
  courier_name_slug: {
    isError: false,
    message: ''
  },
  tracking_code: {
    isError: false,
    message: ''
  },
}

const FormAdjustPackageShipment = ({ dataPackageShipment, onCloseForm, reloadList }) => {
  const params = useParams()
  const orderId = params.order_id
  const [loadingForm, setLoadingForm] = useState(false)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingCourier, setLoadingCourier] = useState(true)
  const [firstMileCouriersList, setFirstMileCouriersList] = useState([])
  const [lastMileCouriersList, setLastMileCouriersList] = useState([])

  const submitPackageShipment = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''
    let payload = {}
    const validateForm = {
      courier_name_slug: form.courier_name_slug,
      tracking_code: form.tracking_code,
    }
    
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    if (dataPackageShipment === null) {
      payload = {
        courier_name_slug: form.courier_name_slug,
        tracking_code: form.tracking_code,
        last_mile_courier: form.courier_name_slug === 'acn' ? form.last_mile_courier : null,
        tracking_code_courier: form.courier_name_slug === 'acn' ? form.tracking_code_courier : null,
        estimated_arrival: form.estimated_arrival,
        estimated_departure: form.estimated_departure,
        port_of_landing: form.port_of_landing,
        port_of_destination: form.port_of_destination,
        order_id: orderId
      }
      methodFunction = addPackageShipment(payload)
      titleMessageSuccess = 'Add Package Shipment Successfully'
      captionMessageSuccess = 'You have been added new package shipment'
      titleMessageError = 'Add Package Shipment Error'
    } else {
      payload = {
        courier_name_slug: form.courier_name_slug,
        tracking_code: form.tracking_code,
        last_mile_courier: form.courier_name_slug === 'acn' ? form.last_mile_courier : null,
        tracking_code_courier: form.courier_name_slug === 'acn' ? form.tracking_code_courier : null,
        estimated_arrival: form.estimated_arrival,
        estimated_departure: form.estimated_departure,
        port_of_landing: form.port_of_landing,
        port_of_destination: form.port_of_destination,
        order_id: orderId
      }
      methodFunction = updatePackageShipment(dataPackageShipment.id, payload)
      titleMessageSuccess = 'Update Package Shipment Successfully'
      captionMessageSuccess = 'You have been updated data package shipment'
      titleMessageError = 'Update Package Shipment Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        onCloseForm()
        reloadList()
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetCourierList = async () => {
    setLoadingCourier(true)
    const params = {
      'page[num]': 1,
      'page[limit]': 9999,
      'sort': 'name'
    }
    try {
      const response = await getAllCourierList(params)
      if (response.success) {
        const dataCourier = response.data

        const remapDataFirstMile = dataCourier.map((val) => {
          let data = {
            value: '',
            label: ''
          }
          if (val.attributes.name_slug !== '') {
            data = {
              value: val.attributes.name_slug,
              label: `${val.attributes.name === 'acn' ? 'Asiacommerce' : `${val.attributes.name} (${val.attributes.tracking_system.charAt(0).toUpperCase() + val.attributes.tracking_system.slice(1)})`}`,
            }
          }
          return data
        })
        
        const remapDataLastMile = dataCourier.map((val) => {
          let data = {
            value: '',
            label: ''
          }
          if (val.attributes.name_slug !== '' && val.attributes.tracking_system !== 'acn') {
            data = {
              value: val.attributes.name_slug,
              label: `${`${val.attributes.name} (${val.attributes.tracking_system.charAt(0).toUpperCase() + val.attributes.tracking_system.slice(1)})`}`,
            }
          }
          return data
        })


        const filterDataDuplicate = (data) => data.reduce((result, item) => {
          const removed = result.filter((val) => val.value !== item.value)
          return [...removed, item]
        }, [])

        
        setFirstMileCouriersList(filterDataDuplicate(remapDataFirstMile))
        setLastMileCouriersList(filterDataDuplicate(remapDataLastMile))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCourier(false)
    }
  }

  useEffect(() => {
    handleGetCourierList()
    if (dataPackageShipment !== null) {
      handleSetForm(dataPackageShipment)
    }
  }, [dataPackageShipment])

  useEffect(() => {
    handlingCustomTrackingCode(formData, dataPackageShipment)
    // eslint-disable-next-line
  }, [formData.courier_name_slug, dataPackageShipment])

  const handleSetForm = (val) => {
    const detail = {
      id: val.id,
      courier_name_slug: val.courier_name_slug,
      tracking_code: val.tracking_code,
      last_mile_courier: val.last_mile_slug,
      tracking_code_courier: val.tracking_code_courier,
      estimated_arrival: val.estimated_arrival,
      estimated_departure: val.estimated_departure,
      port_of_landing: val.port_of_landing,
      port_of_destination: val.port_of_destination
    }
    setFormData(detail)
  }

  const handlingCustomTrackingCode = (form, dataPackageShipment) => {
    console.log(dataPackageShipment)
    if (dataPackageShipment === null) {
      if (form.courier_name_slug === 'acn') {
        const generateTrackingCode = 'ACN-TR-' + Math.floor(Math.random() * 10000000 + 1)
        handleChangeForm('tracking_code', generateTrackingCode)
      } else {
        handleChangeForm('tracking_code', '')
      }
    } else {
      if (form.courier_name_slug === 'acn') {
        const currentTrackingCode = dataPackageShipment.tracking_code
        const generateTrackingCode = 'ACN-TR-' + Math.floor(Math.random() * 10000000 + 1)
        handleChangeForm('tracking_code', !currentTrackingCode.includes('ACN-TR') ? generateTrackingCode : currentTrackingCode)
      } else {
        const currentTrackingCode = dataPackageShipment.tracking_code
        handleChangeForm('tracking_code', currentTrackingCode.includes('ACN-TR') ? '' : currentTrackingCode)
      }
    }
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const loadForm = () => {

    const loadFormLastMile = () => {
      return (
        <Card withBorder shadow="xs" radius="md" padding='md'>
          <Card.Section inheritPadding py="xs">
            <Group gap='sm' align='center' py={6}>
              <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                <IconTruck style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Box>
                <Title size={16} c='violet.8'>Last Mile</Title>
                <Text fz={10} c='red'>The first mile you select requires last mile information.</Text>
              </Box>
            </Group>
          </Card.Section>
          <Box my={10}>
            <Box mb='sm'>
              <Select
                name='last_mile_courier'
                value={formData.last_mile_courier}
                label='Last Mile Courier'
                placeholder='Select last mile courier'
                data={lastMileCouriersList}
                onChange={(val) => handleChangeForm('last_mile_courier', val)}
                size='xs'
                searchable
                nothingFoundMessage="No Courier Found"
                clearable
                allowDeselect={false}
              />
            </Box>
            <Box mb='sm'>
              <TextInput
                name='tracking_code_courier'
                value={formData.tracking_code_courier}
                label='Last Mile Tracking Code'
                placeholder='Input last mile tracking code'
                onChange={(val) => handleChangeForm('tracking_code_courier', val.target.value)}
                size='xs'
              />
            </Box>
          </Box>
        </Card>
      )
    }

    return (
      <Box>
        <SimpleGrid cols={2} verticalSpacing="md" mb='sm'>
          <Box>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Card.Section inheritPadding py="xs">
                <Group gap='sm' align='center' py={6}>
                  <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                    <IconShip style={{ width: '70%', height: '70%' }} />
                  </ThemeIcon>
                  <Title size={16} c='violet.8'>First Mile</Title>
                </Group>
              </Card.Section>
              <Box my={10}>
                <Box mb='sm'>
                  <Select
                    name='courier_name_slug'
                    value={formData.courier_name_slug}
                    label='First Mile'
                    placeholder='Select first mile'
                    error={validationForm.courier_name_slug.isError ? `${validationForm.courier_name_slug.message}` : ''}
                    data={firstMileCouriersList}
                    onChange={(val) => handleChangeForm('courier_name_slug', val)}
                    size='xs'
                    searchable
                    nothingFoundMessage="No Courier Found"
                    clearable
                    withAsterisk
                    allowDeselect={false}
                  />
                </Box>
                <Box mb='sm'>
                  <TextInput
                    name='tracking_code'
                    value={formData.tracking_code}
                    label='First Mile Tracking Code'
                    placeholder='Input first mile tracking code'
                    error={validationForm.tracking_code.isError ? `${validationForm.tracking_code.message}` : ''}
                    onChange={(val) => handleChangeForm('tracking_code', val.target.value)}
                    disabled={formData.courier_name_slug === 'acn'}
                    withAsterisk
                    size='xs'
                  />
                </Box>
              </Box>
            </Card>
          </Box>
          <Box>
            {formData.courier_name_slug === 'acn' ? loadFormLastMile() : ''}
          </Box>
          <Box>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Card.Section inheritPadding py="xs">
                <Group gap='sm' align='center' py={6}>
                  <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                    <IconPackage style={{ width: '70%', height: '70%' }} />
                  </ThemeIcon>
                  <Title size={16} c='violet.8'>ETD & ETA</Title>
                </Group>
              </Card.Section>
              <Box my={10}>
                <Box mb='sm'>
                  <TextInput
                    name='estimated_departure'
                    value={formData.estimated_departure}
                    label='Estimated time of Departure'
                    placeholder='eg., February 3, 2024'
                    onChange={(val) => handleChangeForm('estimated_departure', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box mb='sm'>
                  <TextInput
                    name='estimated_arrival'
                    value={formData.estimated_arrival}
                    label='Estimated time of Arrival'
                    placeholder='eg., February 3, 2024'
                    onChange={(val) => handleChangeForm('estimated_arrival', val.target.value)}
                    size='xs'
                  />
                </Box>
              </Box>
            </Card>
          </Box>
          <Box>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Card.Section inheritPadding py="xs">
                <Group gap='sm' align='center' py={6}>
                  <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                    <IconPackage style={{ width: '70%', height: '70%' }} />
                  </ThemeIcon>
                  <Title size={16} c='violet.8'>POL & POD</Title>
                </Group>
              </Card.Section>
              <Box my={10}>
                <Box mb='sm'>
                  <TextInput
                    name='port_of_landing'
                    value={formData.port_of_landing}
                    label='Port Of Landing'
                    placeholder='input port of landing'
                    onChange={(val) => handleChangeForm('port_of_landing', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box mb='sm'>
                  <TextInput
                    name='port_of_destination'
                    value={formData.port_of_destination}
                    label='Port Of Destination'
                    placeholder='input port of destination'
                    onChange={(val) => handleChangeForm('port_of_destination', val.target.value)}
                    size='xs'
                  />
                </Box>
              </Box>
            </Card>
          </Box>
        </SimpleGrid>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitPackageShipment(formData)}>{dataPackageShipment ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }


  return (
    <Box>
      {loadingCourier ? <LoadingData /> : loadForm()}
    </Box>
  )
}

export default FormAdjustPackageShipment